import _ from "lodash";
import update from "immutability-helper";
import client from "lib/apolloClient/client";
import {
  createPostMutation,
  updatePostMutation,
  updateAssignmentToJournalMutation,
  bulkCourseFoldersActionsMutation,
  createAIConversationMutation,
  updateAiConversationMutation,
  createAttachmentGroupsMutation,
} from "Post/modules/PostMutations";
import { upsertActivityPostCommentsAsReadMutation } from "Post/modules/ActivityTrackingMutation";
import {
  getCoursePostFeedQuery,
  getCourseAllStudentQuery,
  getLearningCourseStandardsQuery,
} from "Post/modules/PostQuery";
import { generateRandomId } from "Utils";
import { getCourseFolders } from "Journal/modules/JournalQuery";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import {
  getPostDetailsFromCache,
  readCommentOfPostFromCache,
  writeCommentOfPostInCache,
  readPostCommentFragment,
  writePostCommentFragment,
  readActivityLikesAndCommentsFragment,
  writeActivityLikesAndCommentsFragment,
  getAttachmentGroupsOfNodeForStudentAssignmentFromCache,
  writeAttachmentGroupsOfNodeForStudentAssignmentInCache,
} from "Post/modules/PostGraphqlHelpers";
import {
  uploadFileV2,
  getAIResponse,
  createAIMessage,
  isExcludedParentTypesForAttachmentCache,
} from "modules/Services";
import { updateFilterObject } from "Journal/modules/JournalModule";
import { getCloudUrl } from "Constants";
import { getFieldUids } from "modules/TaggableElementsUtils";
import {
  getPracticesV2InputForPost,
  getAddedPracticesV2,
  getRemovedPracticesV2,
  hasTranslationPermission,
  getPostTranslationFilter,
  compareRatingObjects,
  getNestedTaggedLearningGoalsIds,
  getRatingsCollectively,
  isDPSubjectJournalEnabled,
  getStudentActivityInput,
  getModifiedStudentActivitiesInput,
  getIdsOfRemovedStudentActivities,
  isPortfolioParityEnabled,
  replaceCaptionWithIdAndNameMapping,
  isPortfolioAIEnabledAndIsJournalRoute,
  cleanNoteMessage,
  isPortfolioReviewSetupEnabledAndIsReviewRoute,
  isPortfolioReviewSetupEnabled,
  formatTaggedEntityCreateInput,
  getIsNewGoalTaggingEnabled,
  formatTaggedEntityUpdateInput,
  getIsBulkAssignmentPostCreationEnhancementEnabled,
  getShouldShowFolderCount,
  getIsSchedulePostTabEnabled,
} from "Post/utils";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_PYP,
  APPROVED_EVIDENCE_STATUS,
  SUGGESTED_EVIDENCE_STATUS,
} from "Constants/stringConstants";
import {
  getStudentAssignmentDetailsQuery,
  getAssignmentDetailsQuery,
} from "ClassRoom/modules/ClassRoomQuery";
import {
  getAssignmentDetailsQueryVariables,
  getToolResponseUserFilter,
} from "ClassRoom/modules/utils";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import { getCourseDetailsQuery } from "Course/modules/CourseQuery";
import { ATTACHMENT_OMIT_ATTRIBUTES } from "store/static";
import ACLStore from "lib/aclStore";
import {
  createMessageMutation,
  deleteAttachmentMutation,
  deleteMessageMutation,
  updateMessageMutation,
} from "modules/CommonMutations";
import moment from "moment";
import { getUserBasicDetailsFromCache } from "modules/CommonGraphqlHelpers";
import { getTaggedPostStudentFolders } from "routes/routes/Teacher/routes/Courses/routes/Course/routes/Journal/modules/JournalQuery";
import { hasModuleAdminAccess, MODULES } from "lib/staffPermissionUtils";
import { getPostFeedFilters } from "Journal/modules/Utils";
import { handlePostCreationForStudentGoal } from "Teacher/routes/StudentGoals/components/RightPane/modules/RightPaneModule";
import { colors } from "@toddle-edu/ds-theme";
import {
  getSelectedAcademicYearId,
  getCurrentCurriculumProgramType,
  getSelectedCurriculumId,
  getAcademicYearId,
} from "modules/CommonSelectors";

import { getOrganizationPostFeedQuery } from "Teacher/routes/PortfolioReview/modules/PortfolioReviewQuery";

import {
  readRoutineLikesAndCommentsFragment,
  writeRoutineLikesAndCommentsFragment,
} from "AppComponents/Routines/modules/RoutineGraphqlhelpers";
import {
  getIsCourseBasedGradingEnabled,
  getIsSubjectBasedGradingEnabled,
} from "Teacher/routes/LearningCourses/modules/Utils";
import { getSelectedLearningCourseId } from "Teacher/routes/LearningCourse/modules/Utils";

import { Sentry } from "services/sentry";

export const NAME = "post";
export const BLANK_OBJECT = {};
export const UPDATE_POST = "UPDATE_POST" + " " + NAME;
export const UPDATE_STUDENT_LIST_FILTERS =
  "UPDATE_STUDENT_LIST_FILTERS" + " " + NAME;
export const RESET_POST = "RESET_POST" + " " + NAME;

export const POST_TYPE_DETAILS = [
  {
    value: "PUBLISHED",
    label: "Published",
    key: "published",
    orderBy: "PUBLISHED_AT",
    user: "student",
  },
  {
    value: "SCHEDULED",
    label: "Scheduled",
    key: "scheduled",
    orderBy: "PUBLISHED_AT",
    user: "staff",
  },
  {
    value: "DRAFT",
    label: "Draft",
    key: "draft",
    orderBy: "CREATED_AT", // changing to CREATED_AT as we show CREATED_AT in post card
    user: "staff",
  },
  {
    value: "IN_APPROVAL",
    label: "In Approval",
    key: "inApproval",
    orderBy: "CREATED_AT", // changing to CREATED_AT as we show CREATED_AT in post card
    user: "student",
  },
];

export const POST_TYPE_DETAILS_REVIWERS_FLOW = [
  {
    value: "PUBLISHED",
    label: "Published",
    key: "published",
    orderBy: "PUBLISHED_AT",
    user: "student",
    locale: "published",
  },
  {
    value: "DRAFT",
    label: "Draft",
    key: "draft",
    orderBy: "CREATED_AT", // changing to CREATED_AT as we show CREATED_AT in post card
    user: "staff",
    locale: "draft",
  },
  {
    value: "IN_APPROVAL",
    label: "student_approval",
    key: "inApproval",
    orderBy: "CREATED_AT", // changing to CREATED_AT as we show CREATED_AT in post card
    user: "student",
    locale: "student_approval",
  },
  {
    value: "IN_APPROVAL_STAFF",
    label: "reviewer_approval",
    key: "reviewer_approval",
    orderBy: "CREATED_AT", // changing to CREATED_AT as we show CREATED_AT in post card
    user: "staff",
    locale: "reviewer_approval",
  },
];

export const POST_TYPE_DETAILSV2 = [
  {
    value: "PUBLISHED",
    label: "Published",
    key: "published",
    orderBy: "PUBLISHED_AT",
    user: "student",
  },
  {
    value: "SCHEDULED",
    label: "Scheduled",
    key: "scheduled",
    orderBy: "PUBLISHED_AT",
    user: "staff",
  },
  {
    value: "DRAFT",
    label: "Draft",
    key: "draft",
    orderBy: "CREATED_AT", // changing to CREATED_AT as we show CREATED_AT in post card
    user: "student",
  },
  {
    value: "IN_APPROVAL",
    label: "In Approval",
    key: "inApproval",
    orderBy: "CREATED_AT", // changing to CREATED_AT as we show CREATED_AT in post card
    user: "student",
  },
];

export const SUBJECT_JOURNAL_HEADER_TABS = [
  {
    label: "Overview",
    value: "OVERVIEW_TAB",
  },
  {
    label: "Portfolio",
    value: "JOURNAL_TAB",
  },
];

export const POST_STATUS_FILTER_OPTIONS = [
  {
    label: "All",
    key: "ALL",
  },
  {
    label: "Published",
    key: "PUBLISHED",
  },
  {
    label: "Draft",
    key: "DRAFT",
  },
];

// NOTE: TAGGABLE_PYP_ELEMENTS / TAGGABLE_PYP_ELEMENTS_V2 / TAGGABLE_DP_ELEMENTS /
// TAGGABLE_DP_ELEMENTS_V2 / TAGGABLE_MYP_ELEMENTS / TAGGABLE_MYP_ELEMENTS_V2 /
// TAGGABLE_UBD_ELEMENTS and TAGGABLE_ELEMENTS_FIELD_LIST were moved to
// src/Constants/taggableElements.js — they are curriculum-element data, not
// Post-domain data, and were causing a circular dep with modules/ElementValueUtils.

const OMIT_ATTRIBUTES_OF_ATTACHMENTS = [
  "file",
  "id",
  "similarityReport",
  "isPost",
  "createdBy",
  "attachmentId",
  "questionAttachment",
  "isAnnotationRead",
  "signedUrl",
];

const NOTES_REQUIRED_ATTRIBUTES = ["title", "type"];

// ACTIVITY TRACKING CONSTS
export const ACTIVITY_FOOD = "ACTIVITY_FOOD";
export const ACTIVITY_NAP = "ACTIVITY_NAP";
export const ACTIVITY_TOILET = "ACTIVITY_TOILET";

export const STEP_BY_ACTIVITY_TYPE = {
  [ACTIVITY_FOOD]: "MANAGE_FOOD_ACTIVITY",
  [ACTIVITY_NAP]: "MANAGE_NAP_ACTIVITY",
  [ACTIVITY_TOILET]: "MANAGE_TOILET_ACTIVITY",
};

export const COLORS_MAPPING_FOR_TAG = {
  "#00aff1": "blue",
  "#92f2ff": "blue",
  "#fecfd8": "pink",
  "#ffdf99": "yellow",
  "#a2ecd8": "teal",
  "#c5c5fc": "violet",
  "#e7ccf5": "purple",
  "#d4f197": "green",
  "#ffc9a0": "orange",
};

const BASE_COLORS_MAPPING_FOR_CHIP = {
  blue: colors.blue800,
  pink: colors.pink800,
  violet: colors.violet800,
  yellow: colors.yellow800,
  teal: colors.teal800,
  orange: colors.orange800,
  green: colors.green800,
  purple: colors.purple800,
};
export const COLORS_MAPPING_FOR_CHIP = {
  ...BASE_COLORS_MAPPING_FOR_CHIP,
  ..._.reduce(
    _.keys(COLORS_MAPPING_FOR_TAG),
    (aux, hexColor) => {
      //add appropriate surface colors for hex color code strings
      aux[hexColor] =
        BASE_COLORS_MAPPING_FOR_CHIP[COLORS_MAPPING_FOR_TAG[hexColor]];
      return aux;
    },
    {}
  ),
};

// NOTE: getDynamicPlannerElementLabelStatus / getFieldList / getTaggableElements /
// getTaggableElementsMemoized / getAllTaggableElements / getFieldUids /
// getFieldUidsMemoize / getTaggableElementsWithDynamicLabels were moved to
// src/modules/TaggableElementsUtils.js — they are curriculum-element helpers,
// not Post-domain logic. getFieldUids is still imported back in this file
// because two thunks below (editPost, createPost) call it directly.

const getPostCreationToastMessage = ({
  state,
  publishedAt,
  isUpdate = false,
  oldPublishedAt,
}) => {
  const toastMessage = {
    msg: isUpdate
      ? _.isEqual(state, "REJECTED")
        ? "journal:post_return_for_review"
        : "toastMsgs:post_updated_successfully"
      : "toastMsgs:post_successfully_published",
  };
  // SCHEDULED post case
  if (
    !_.isNil(publishedAt) &&
    ((!isUpdate && moment(publishedAt).isAfter(moment().toISOString())) ||
      (isUpdate &&
        !_.isNil(oldPublishedAt) &&
        moment(publishedAt).isAfter(moment(oldPublishedAt).toISOString()))) &&
    (state === "PUBLISHED" || state === "SCHEDULED")
  ) {
    toastMessage.msg = "toastMsgs:post_scheduled_successfully_with_time";
    toastMessage.locale_params = [
      {
        key: "time",
        value: moment(publishedAt).format("lll"),
        isPlainText: true,
      },
    ];
    return toastMessage;
  }

  // BACKDATED post case
  if (
    state === "PUBLISHED" &&
    !_.isNil(publishedAt) &&
    ((!isUpdate && moment(publishedAt).isBefore(moment().toISOString())) ||
      (isUpdate &&
        !_.isNil(oldPublishedAt) &&
        moment(publishedAt).isBefore(moment(oldPublishedAt).toISOString())))
  ) {
    toastMessage.msg = "toastMsgs:post_backdated_successfully";
    return toastMessage;
  }

  switch (state) {
    case "PUBLISHED":
      toastMessage.msg = isUpdate
        ? "toastMsgs:post_updated_successfully"
        : "toastMsgs:post_successfully_published";
      break;
    case "DRAFT":
      toastMessage.msg = "toastMsgs:post_saved_as_draft";
      break;
    case "IN_APPROVAL":
      toastMessage.msg = "toastMsgs:post_sent_for_approval";
      break;
  }

  return toastMessage;
};

export const updatePost = data => {
  return { type: UPDATE_POST, data: data };
};
export const resetPost = () => {
  return { type: RESET_POST };
};

export const updateStudentListFilters = data => {
  return { type: UPDATE_STUDENT_LIST_FILTERS, data: data };
};

const REDUCER_HANDLERS = {
  [UPDATE_POST]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        postDetails: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [RESET_POST]: (state, action) => {
    return update(state, {
      postDetails: { $set: initialState.postDetails },
    });
  },
  [UPDATE_STUDENT_LIST_FILTERS]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        studentListFilters: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
};

export const updatePostRatingsCollectively = data => {
  return async (dispatch, getState) => {
    const students = _.get(getState(), "post.postDetails.students.edges", []);

    const collectiveRatings = getRatingsCollectively({
      currentRatings: data?.currentRatings,
      newRating: data?.newRating,
      students: students,
    });
    dispatch(updatePost({ ibPYPElementRatings: [...collectiveRatings] }));
    return [...collectiveRatings];
  };
};
export const updateFolderArray = data => {
  return async (dispatch, getState) => {
    const postDetails = getState().post.postDetails;
    const postId = getState().post.postDetails.id;
    const folders = postDetails.folders;

    //new
    //  set it into folders
    if (!postId) {
      dispatch(updatePost({ folders: data }));
    } else {
      const addedFolders = _.differenceWith(
        data,
        folders,
        (folder1, folder2) => folder1?.id == folder2?.id
      );
      const removedFolders = _.differenceWith(
        folders,
        data,
        (folder1, folder2) => folder1?.id == folder2?.id
      );
      dispatch(updatePost({ addedFolders, removedFolders }));
    }
    //edit
    //  set it into addedFolders, deletedFolders
  };
};

export const updateFolderInArrayByName = data => {
  return async (dispatch, getState) => {
    const postDetails = getState().post.postDetails;
    const folders = postDetails.folders;

    const folderIndex = _.findIndex(folders, folder =>
      _.isEqual(folder?.name, data?.name)
    );
    if (!_.isUndefined(folderIndex)) {
      // set the latest values that we recieved from mutation result (i.e. folder id)
      const updatedFolders = [...folders];
      updatedFolders[folderIndex] = { ...data };
      dispatch(updatePost({ folders: updatedFolders }));
    }
  };
};

export const uploadAttachments = ({ attachments, parentId, parentType }) => {
  return async (dispatch, getState) => {
    const filteredAttachments = _.filter(attachments, attachment => {
      return _.get(attachment, "type") !== "LINK";
    });
    const filteredLinkAttachments = _.filter(attachments, attachment => {
      return _.get(attachment, "type") === "LINK";
    });
    const attachmentsContainBlob = _.some(attachments, attachment => {
      return _.includes(attachment.url, "blob:");
    });
    const allowUploadingBlobFile =
      _.includes(["POST", "STUDENT_ASSIGNMENT_SUBMISSION"], parentType) &&
      isPortfolioParityEnabled() &&
      attachmentsContainBlob;

    const attachmentLength = _.get(attachments, "length", 0);
    const attachmentType = _.get(
      allowUploadingBlobFile ? filteredAttachments[0] : attachments[0],
      "type",
      ""
    );
    const attachmentUrl = _.get(attachments[0], "url", "");

    if (
      attachmentLength > 0 &&
      attachmentType != "NOTE" &&
      attachmentType != "LINK" &&
      attachmentType != "TODDLE_DOC" &&
      (attachmentUrl.search("blob:") > -1 || allowUploadingBlobFile)
    ) {
      const allPromises = _.map(
        allowUploadingBlobFile ? filteredAttachments : attachments,
        async (attachment, index) => {
          const uploadStartTime = Date.now();
          const currentUrl = _.get(attachment, "url", "");
          if (_.includes(currentUrl, getCloudUrl())) {
            // attachment already uploaded on the cloud
            return attachment;
          }
          const url = await dispatch(
            uploadFileV2({
              file: _.get(attachment, "file", {}),
              parentType,
              parentId,
              attachment: attachment,

              uploadId: generateRandomId(),
            })
          );
          const uploadTime = Date.now() - uploadStartTime;
          const metadata = _.get(attachment, "metadata", {});
          const updatedMetadata = { ...metadata, uploadTime };
          attachment = { ...attachment, metadata: updatedMetadata };
          return {
            ..._.omit(attachment, [
              "file",
              "id",
              "streamUrl",
              "signedUrl",
              "isRead",
              "questionAttachment",
            ]),
            url,
            displaySequence: index + 1,
          };
        }
      );
      attachments = await Promise.all(allPromises);
    }
    return allowUploadingBlobFile
      ? [...filteredLinkAttachments, ...attachments]
      : attachments;
  };
};

export const createMedia = ({ parentId, parentType }) => {
  return async (dispatch, getState) => {
    const postDetails = getState().post.postDetails;
    let { attachments } = postDetails;
    attachments = await dispatch(
      uploadAttachments({ attachments, parentType, parentId })
    );

    // removing id from the attachments if present
    attachments = _.map(attachments, attachment =>
      _.omit(attachment, ["id", "isRead", "questionAttachment", "signedUrl"])
    );
    const attachmentGroups = _.map(attachments, attachment => {
      if (_.isObject(attachment?.createdBy))
        attachment.createdBy = _.get(attachment, "createdBy.id");
      return {
        parentId,
        parentType,
        attachments: [attachment],
      };
    });
    switch (parentType) {
      case "STUDENT_ASSIGNMENT_SUBMISSION":
        await dispatch(
          createAttachmentGroups({
            groupParentType: parentType,
            groupParentId: parentId,
            input: attachmentGroups,
          })
        );
        break;
      case "STUDENT_GOAL":
      case "STUDENT_GOAL_TASK":
        await dispatch(
          handlePostCreationForStudentGoal({ parentType, attachments })
        );
        break;
    }
  };
};
export const updateOrEditPost = ({
  courseIdFromParent,
  isPublishingDraftPost,
  staffAccessPermission,
} = {}) => {
  return async (dispatch, getState) => {
    const postDetails = getState().post.postDetails;
    const currentSelectedStudentInFilter = _.get(
      getState(),
      "journal.filters.studentIds",
      undefined
    );

    const { id: userId, user_type: userType } = getState().login.userInfo;
    const courseId = getState().teacher.selected_class.selected_course;
    if (_.get(postDetails, "id", "")) {
      await dispatch(editPost({ postDetails, isPublishingDraftPost }));
    } else {
      let { attachments } = postDetails;
      const { state } = postDetails;
      const currentCurriculumProgramType = _.get(
        getState(),
        "platform.currentCurriculumProgram.type",
        CURRICULUM_TYPE_PYP
      );
      let studentIds = undefined;
      const postStudentIds = _.map(
        _.get(postDetails, "students.edges", []),
        student => student?.node?.id
      );
      if (userType == "student") {
        studentIds = userId;
      } else if (
        userType == "staff" &&
        isDPSubjectJournalEnabled(currentCurriculumProgramType)
      ) {
        studentIds = !_.includes(postStudentIds, currentSelectedStudentInFilter)
          ? _.get(postStudentIds, "0", currentSelectedStudentInFilter)
          : currentSelectedStudentInFilter;
      }
      const finalState = isDPSubjectJournalEnabled(currentCurriculumProgramType)
        ? _.get(getState(), "journal.filters.state", "ALL")
        : userType == "student"
        ? isPortfolioParityEnabled()
          ? state
          : undefined
        : state;
      const updateFinalState =
        isPortfolioParityEnabled() &&
        _.isEqual(finalState, "IN_APPROVAL") &&
        _.isEqual(userType, "student")
          ? "PUBLISHED"
          : finalState;
      dispatch(
        updateFilterObject({
          // For DP journal, let the status filter remain as it is set on the feed.
          state:
            isPortfolioReviewSetupEnabled() &&
            !_.includes(staffAccessPermission, "PUBLISH") &&
            _.isEqual(userType, "staff") &&
            _.isEqual(finalState, "IN_APPROVAL")
              ? "IN_APPROVAL_STAFF"
              : updateFinalState,
          studentIds: studentIds,
          orderBy: getOrderBy({
            state: finalState,
            currentCurriculumProgramType,
          }),
          unTagged: false,
        })
      );

      attachments = await dispatch(
        uploadAttachments({ attachments, parentId: null, parentType: "POST" })
      );

      let updatedAttachments = attachments;
      if (
        _.get(postDetails, "isShareEvaluation") &&
        ACLStore.can("FeatureFlag:SendTriggerDocumentPreview") &&
        _.find(attachments, { mimeType: "application/pdf" })
      ) {
        // Add metadata property only to PDF attachments, avoid unnecessary mutation
        updatedAttachments = _.map(attachments, attachment => {
          if (
            _.get(attachment, "mimeType") === "application/pdf" &&
            _.get(attachment, "type") === "FILE"
          ) {
            // Use object spread for immutability and avoid mutating original object
            return {
              ...attachment,
              metadata: {
                ..._.get(attachment, "metadata", {}),
                triggerDocumentPreview: true,
              },
            };
          }
          return attachment;
        });
      }

      await dispatch(
        createPost({
          postDetails: {
            ...postDetails,
            courseId: courseIdFromParent ? courseIdFromParent : courseId,
            attachments: updatedAttachments,
          },
        })
      );
    }
  };
};
export const getOrderBy = ({ state, currentCurriculumProgramType }) => {
  if (
    isDPSubjectJournalEnabled(currentCurriculumProgramType) &&
    state === "ALL"
  )
    return "PUBLISHED_AT";
  return _.get(
    _.find(POST_TYPE_DETAILS, item => item.value == state),
    "orderBy",
    "CREATED_AT"
  );
};

export const getStandardSearchResults = ({ variables }) => {
  return async (dispatch, getState) => {
    const result = await client.query({
      query: getLearningCourseStandardsQuery,
      variables,
      fetchPolicy: "network-only",
    });
    return _.get(result, "data.node", []);
  };
};

const cleanPostMessageTitle = (title, userType) => {
  const updatedTitle = isPortfolioAIEnabledAndIsJournalRoute(userType)
    ? title
        ?.replace(
          /<span style="background-color: rgba\(106, 177, 255, 0.4\);[\s]*padding-top: 3px;">([\s\S]*?)<\/span>/g,
          "$1"
        )
        .replace(/<div>/gi, "\n")
        .replace(/<\/div>/gi, "")
        .replace(/<br>/gi, "\n")
    : title;

  const parser = new DOMParser();
  const doc = parser.parseFromString(updatedTitle, "text/html");
  return _.get(doc, "documentElement.textContent", updatedTitle);
};

export const updatePostStatusV2 = (status, comment) => {
  return async (dispatch, getState) => {
    let postDetails = _.get(getState(), "post.postDetails", {});
    const currentPostState = _.get(postDetails, "state");
    postDetails = { ...postDetails, ...comment, state: status };
    await dispatch(editPost({ postDetails, currentPostState }));
  };
};
export const editPost = ({
  postDetails,
  isPublishingDraftPost,
  currentPostState,
}) => {
  return async (dispatch, getState) => {
    const {
      id,
      title,
      attachments,
      students: { edges: students = [] } = {},
      unitPlan,
      resourceItem,
      resourceType,
      elementPYP,
      state = "DRAFT",
      isPrivate,
      isHiddenFromStudents,
      addedFolders,
      removedFolders,
      taggedPractices,
      originalIsStudentIndividuallyRated: isStudentIndividuallyRated,
      aiConversationId,
      createdBy,
      postTaggedEntity,
      publishedAt,
    } = postDetails;
    const userInfo = getUserInfo();
    const postState = state == "SCHEDULED" ? "PUBLISHED" : state;
    const courseId = _.get(
      postDetails,
      "courseId",
      getState()?.teacher?.selected_class?.selected_course
    );
    const isScheduledPost =
      publishedAt && moment(publishedAt).isAfter(moment());

    //Prevent and track empty post update
    if (!id) {
      Sentry.captureMessage("INVALID_POST_UPDATE_INPUT", {
        extra: {
          createdBy,
          courseId,
          id,
          title,
        },
      });
      return;
    }

    const translationFilter = getPostTranslationFilter({
      userInfo,
      shouldTranslate: false,
      handleTranslation: hasTranslationPermission(),
    });

    const oldPostDetails = getPostDetailsFromCache({
      postId: id,
      translationFilter: translationFilter,
    });

    const evaluationCycleId = _.get(
      _.first(taggedPractices),
      "evaluationCycle.id",
      ""
    );
    const oldTaggedPractices = oldPostDetails.taggedPractices || [];
    const newTaggedPractices = taggedPractices;

    const addedPractices = getAddedPracticesV2({
      oldTaggedPractices,
      newTaggedPractices,
    });

    const removedPractices = getRemovedPracticesV2({
      oldTaggedPractices,
      newTaggedPractices,
    });

    const userId = userInfo.id;
    const userType = userInfo.user_type;
    const studentIds = _.map(students, item => item.node.id);
    const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();
    // Remove ratings if corresponding learning goals are removed from "Tagged learning goals"
    const oldTaggedLearningGoals = [];
    _.forEach(_.get(oldPostDetails, "elementPYP", []), element =>
      oldTaggedLearningGoals.push(
        ...getNestedTaggedLearningGoalsIds(element, _.get(element, "value", []))
      )
    );
    const newTaggedLearningGoals = [];
    _.forEach(_.get(postDetails, "elementPYP", []), element =>
      newTaggedLearningGoals.push(
        ...getNestedTaggedLearningGoalsIds(element, _.get(element, "value", []))
      )
    );

    const postIBPYPElementRatings = _.get(
      postDetails,
      "originalibPYPElementRatings",
      []
    );

    const oldPostIBPYPElementRatings = _.get(
      oldPostDetails,
      "ibPYPElementRatings",
      []
    );
    const derrivedRemovedRatings = [];
    // Any rating that is present in saved ratings (DB), but removed during the post edit will be pushed.
    _.forEach(oldPostIBPYPElementRatings, oldRating => {
      if (
        _.find(postIBPYPElementRatings, newRating => {
          return compareRatingObjects({
            rating1: oldRating,
            rating2: newRating,
          });
        }) == undefined
      ) {
        derrivedRemovedRatings.push(oldRating);
      }
    });

    // Ratings that are present in new edited ratings array but not in saved ratings (DB) array are new/changed rating values.
    const derrivedNewRatings = _.differenceWith(
      postIBPYPElementRatings,
      oldPostIBPYPElementRatings,
      _.isEqual
    );

    // find which learning goals are removed and get the rating IDs
    const deletedRatingIds = _.differenceWith(
      oldTaggedLearningGoals,
      newTaggedLearningGoals,
      _.isEqual
    );

    // Use deletedRatingIds to delete ratings of removed learning goals
    const deleteRatingsInput = [];
    _.forEach(deletedRatingIds, deleteId => {
      const elementRatingsToDelete = _.filter(
        postIBPYPElementRatings,
        rating =>
          `${_.get(rating, "ibPYPElementType", undefined)}_${_.get(
            rating,
            "ibPYPElementId",
            undefined
          )}` == deleteId
      );
      // add every rating value details for removal (for example: Achivements, Afforts, etc)
      _.forEach(elementRatingsToDelete, ratingToDelete => {
        deleteRatingsInput.push({
          studentId: _.get(
            ratingToDelete,
            "studentId",
            _.get(ratingToDelete, "student.id", undefined)
          ),
          parentId: id,
          parentType: "POST",
          academicCriteriaSetId: _.get(
            ratingToDelete,
            "academicCriteriaSet.id",
            undefined
          ),
          ibPYPElementId: _.get(ratingToDelete, "ibPYPElementId", undefined),
          ibPYPElementType: _.get(ratingToDelete, "ibPYPElementType", ""),
          academicTermId: _.get(ratingToDelete, "academicTerm.id", null),
        });
      });
    });

    // Remove ratings of the student who is untagged during edit post
    const oldTaggedStudents = _.get(oldPostDetails, "students.edges", []);
    const newTaggedStudents = _.get(postDetails, "students.edges", []);

    const deletedStudents = [];
    _.forEach(oldTaggedStudents, oldStudent => {
      if (
        _.find(
          newTaggedStudents,
          newStudent => newStudent?.node?.id == oldStudent?.node?.id
        ) == undefined
      ) {
        deletedStudents.push(oldStudent);
      }
    });

    _.forEach(deletedStudents, deletedStudent => {
      const elementRatingsToDelete = _.filter(
        postIBPYPElementRatings,
        rating =>
          _.get(rating, "studentId", _.get(rating, "student.id", undefined)) ==
          deletedStudent?.node?.id
      );
      // add every rating value details for removal (for example: Achivements, Afforts, etc)
      _.forEach(elementRatingsToDelete, ratingToDelete => {
        deleteRatingsInput.push({
          studentId: _.get(
            ratingToDelete,
            "studentId",
            _.get(ratingToDelete, "student.id", undefined)
          ),
          parentId: id,
          parentType: "POST",
          academicCriteriaSetId: _.get(
            ratingToDelete,
            "academicCriteriaSet.id",
            undefined
          ),
          ibPYPElementId: _.get(ratingToDelete, "ibPYPElementId", undefined),
          ibPYPElementType: _.get(ratingToDelete, "ibPYPElementType", ""),
          academicTermId: _.get(ratingToDelete, "academicTerm.id", null),
        });
      });
    });

    _.forEach(derrivedRemovedRatings, rating => {
      deleteRatingsInput.push({
        studentId: _.get(
          rating,
          "studentId",
          _.get(rating, "student.id", undefined)
        ),
        parentId: id,
        parentType: "POST",
        academicCriteriaSetId: _.get(
          rating,
          "academicCriteriaSet.id",
          undefined
        ),
        ibPYPElementId: _.get(rating, "ibPYPElementId", undefined),
        ibPYPElementType: _.get(rating, "ibPYPElementType", ""),
        academicTermId: _.get(rating, "academicTerm.id", null),
      });
    });

    // New ratings to update/save
    const selectedGoalsRatings = [];
    _.forEach(elementPYP, element => {
      selectedGoalsRatings.push(
        ...getNestedTaggedLearningGoalsIds(element, _.get(element, "value", []))
      );
    });

    const isTermChanged =
      _.get(oldPostDetails, "academicTerm.id") !=
      _.get(postDetails, "academicTerm.id");

    const ibPYPElementRatingsInput = [];
    _.forEach(derrivedNewRatings, rating => {
      if (
        (_.some(
          selectedGoalsRatings,
          selectedRating =>
            selectedRating ==
            `${_.get(rating, "ibPYPElementType", undefined)}_${_.get(
              rating,
              "ibPYPElementId",
              undefined
            )}`
        ) ||
          rating?.ibPYPElementType === "DP_SUBJECT") &&
        !_.isUndefined(_.get(rating, "studentId", _.get(rating, "student.id")))
      ) {
        const studentRating = {
          studentId: _.get(
            rating,
            "studentId",
            _.get(rating, "student.id", undefined)
          ),
          parentType: "POST",
          academicCriteriaValueId: _.get(
            rating,
            "academicCriteriaValue.id",
            undefined
          ),
          academicCriteriaSetId: _.get(
            rating,
            "academicCriteriaSet.id",
            undefined
          ),
          ibPYPElementId: _.get(rating, "ibPYPElementId", undefined),
          ibPYPElementType: _.get(rating, "ibPYPElementType", ""),
          createdBy: userInfo.id,
          parentId: id,
          subjectId:
            !getIsCourseBasedGradingEnabled() ||
            getIsSubjectBasedGradingEnabled()
              ? _.get(rating, "subjectId", undefined)
              : undefined,
          learningCourseId: getIsCourseBasedGradingEnabled()
            ? _.get(
                rating,
                "learningCourseId",
                getSelectedLearningCourseId(getState())
              )
            : undefined,
          academicTermId: !_.isNil(_.get(rating, "academicTerm.id", null))
            ? _.get(rating, "academicTerm.id", null)
            : _.get(postDetails, "academicTerm.id", null),
        };
        ibPYPElementRatingsInput.push(studentRating);
      }
    });

    // If term is changed, then we need to remove all the ratings of the old term,
    // and add new ratings (with same values) of the new term.
    let finalNewRatings = ibPYPElementRatingsInput;
    let finalRemovedRatings = deleteRatingsInput;
    if (isTermChanged) {
      finalNewRatings = [];
      finalRemovedRatings = [];
      _.forEach(oldPostIBPYPElementRatings, rating => {
        finalRemovedRatings.push({
          studentId: _.get(
            rating,
            "studentId",
            _.get(rating, "student.id", undefined)
          ),
          parentId: id,
          parentType: "POST",
          academicCriteriaSetId: _.get(
            rating,
            "academicCriteriaSet.id",
            undefined
          ),
          ibPYPElementId: _.get(rating, "ibPYPElementId", undefined),
          ibPYPElementType: _.get(rating, "ibPYPElementType", ""),
          academicTermId: _.get(rating, "academicTerm.id", null),
        });
      });

      _.forEach(postIBPYPElementRatings, rating => {
        if (
          _.some(
            selectedGoalsRatings,
            selectedRating =>
              selectedRating ==
              `${_.get(rating, "ibPYPElementType", undefined)}_${_.get(
                rating,
                "ibPYPElementId",
                undefined
              )}`
          ) &&
          !_.isUndefined(
            _.get(rating, "studentId", _.get(rating, "student.id"))
          )
        )
          finalNewRatings.push({
            studentId: _.get(
              rating,
              "studentId",
              _.get(rating, "student.id", undefined)
            ),
            parentType: "POST",
            academicCriteriaValueId: _.get(
              rating,
              "academicCriteriaValue.id",
              undefined
            ),
            academicCriteriaSetId: _.get(
              rating,
              "academicCriteriaSet.id",
              undefined
            ),
            learningCourseId: getIsCourseBasedGradingEnabled()
              ? _.get(
                  rating,
                  "learningCourseId",
                  getSelectedLearningCourseId(getState())
                )
              : undefined,
            ibPYPElementId: _.get(rating, "ibPYPElementId", undefined),
            ibPYPElementType: _.get(rating, "ibPYPElementType", ""),
            createdBy: userInfo.id,
            parentId: id,
            subjectId:
              !getIsCourseBasedGradingEnabled() ||
              getIsSubjectBasedGradingEnabled()
                ? _.get(rating, "subjectId", undefined)
                : undefined,
            academicTermId: _.get(postDetails, "academicTerm.id", null),
          });
      });
    }
    const addedFromExistingFolders = _.filter(
      addedFolders,
      folder => _.get(folder, "isNewTag", false) == false
    );
    const addedFolderNames = _.map(
      _.filter(
        addedFolders,
        folder => _.get(folder, "isNewTag", false) == true
      ),
      folder => _.get(folder, "name", "")
    );

    const createFolders = _.map(
      _.filter(
        addedFolders,
        folder => _.get(folder, "isNewTag", false) == true
      ),
      folder => ({
        name: _.get(folder, "name", ""),
        color: _.get(folder, "color", ""),
      })
    );
    const taggedStudentFoldersRefetchQuery = [];
    if (
      isDPSubjectJournalEnabled(
        _.get(
          getState(),
          "platform.currentCurriculumProgram.type",
          CURRICULUM_TYPE_PYP
        )
      )
    ) {
      taggedStudentFoldersRefetchQuery.push({
        query: getTaggedPostStudentFolders,
        variables: {
          courseId: courseId,
          studentIds: _.compact(_.map(students, item => item.node.id)),
        },
      });
    }

    const attachmentDiffComparator = (attachment1, attachment2) =>
      _.get(attachment1, "id") == _.get(attachment2, "id");
    let addAttachments = _.map(
      _.differenceWith(
        _.get(postDetails, "attachments", []),
        _.get(oldPostDetails, "attachments", []),
        attachmentDiffComparator
      ),
      attachment => {
        if (_.get(attachment, "type") == "NOTE") {
          // if attachment is note we need only two attributes. (title, type)
          return _.pick(attachment, NOTES_REQUIRED_ATTRIBUTES);
        } else return attachment;
      }
    );
    if (
      _.size(_.get(oldPostDetails, "attachments", [])) &&
      isPortfolioParityEnabled()
    ) {
      addAttachments = _.filter(
        _.get(postDetails, "attachments", []),
        (item, index) => {
          const currentAttachment = _.nth(
            [..._.get(oldPostDetails, "attachments", []), ...addAttachments],
            index
          );
          return (
            currentAttachment &&
            (!_.isEqual(currentAttachment.id, item.id) ||
              _.includes(_.get(currentAttachment, "id"), "NEW_") ||
              _.isUndefined(_.get(currentAttachment, "id")))
          );
        }
      );
    }
    addAttachments = _.map(addAttachments, attachment => {
      if (_.includes(_.get(attachment, "id"), "NEW_")) {
        return _.omit(attachment, ["id", "signedUrl"]);
      } else {
        return _.omit(attachment, ["signedUrl"]);
      }
    });
    const removeAttachments = _.differenceWith(
      _.get(oldPostDetails, "attachments", []),
      _.get(postDetails, "attachments", []),
      attachmentDiffComparator
    );

    // Check note attachment has been updated or not by its content. (NOT ID)
    const oldNotes = _.filter(
      _.get(oldPostDetails, "attachments", []),
      attachment => _.get(attachment, "type", "") == "NOTE"
    );
    const newNotes = _.filter(
      _.get(postDetails, "attachments", []),
      attachment => _.get(attachment, "type", "") == "NOTE"
    );

    _.forEach(oldNotes, note => {
      const newNote = _.find(newNotes, newNote => newNote?.id == note?.id);
      if (!_.isNil(newNote)) {
        if (_.get(newNote, "title") != _.get(note, "title")) {
          addAttachments.push(_.pick(newNote, NOTES_REQUIRED_ATTRIBUTES)); // Add new updated note.
          removeAttachments.push(note); // remove old note
        }
      }
    });

    let updatedAttachments = [];
    _.map(addAttachments, item => {
      if (_.get(item, "type") === "NOTE") {
        _.set(
          item,
          "title",
          cleanNoteMessage(_.get(item, "title")?.trim(), userType)
        );
      }
      updatedAttachments.push(
        _.omit(item, ["streamUrl", "__typename", "isRead"])
      );
    });

    const originalStudentActivityData = _.get(
      getState(),
      "post.postDetails.originalStudentActivityData",
      {}
    );
    const studentActivityData = _.get(
      getState(),
      "post.postDetails.studentActivityData",
      {}
    );

    const isActivityTypePost = !_.isNil(
      _.find(
        _.get(oldPostDetails, "items"),
        item => _.get(item, "itemType") === "STUDENT_ACTIVITY"
      )
    );
    let studentActivitiesInput = undefined;
    if (isActivityTypePost) {
      const modifiedStudentActivitiesInput = getModifiedStudentActivitiesInput({
        originalStudentActivityData,
        studentActivityData,
        userId,
        taggedStudentsIds: _.map(
          _.intersectionBy(oldTaggedStudents, newTaggedStudents, "node.id"),
          student => student?.node?.id
        ),
      });
      const removedStudentActivitiesInput = getIdsOfRemovedStudentActivities({
        originalStudentActivityData,
        removedStudentIds: _.map(deletedStudents, student => student?.node?.id),
      });
      const newAddedStudentActivitiesInput = getStudentActivityInput({
        postDetails: postDetails,
        userId,
        taggedStudents: _.differenceWith(
          newTaggedStudents,
          oldTaggedStudents,
          (student1, student2) =>
            _.get(student1, "node.id") == _.get(student2, "node.id", null)
        ),
      });
      studentActivitiesInput = {
        updatedStudentActivities: modifiedStudentActivitiesInput,
        removedStudentActivities: removedStudentActivitiesInput,
        addedStudentActivities: newAddedStudentActivitiesInput,
      };
    }
    if (_.size(updatedAttachments) > 0) {
      updatedAttachments = await dispatch(
        uploadAttachments({
          attachments: updatedAttachments,
          parentId: null,
          parentType: "POST",
        })
      );
    }

    const curriculumProgramType = getState().platform.currentCurriculumProgram
      .type;
    const fieldUids = getFieldUids({ curriculumProgramType });

    const refetchQueryFilters = getPostFeedFilters({
      userType: userType,
      filters: isPortfolioReviewSetupEnabled()
        ? updateFiltersObject(
            getReviewerPostFilters(
              _.get(getState(), "journal.filters"),
              userInfo
            )
          )
        : _.get(getState(), "journal.filters"),
    });
    if (refetchQueryFilters?.states === "IN_APPROVAL") {
      delete refetchQueryFilters.states;
    }
    const isGoalTaggingEnabled = getIsNewGoalTaggingEnabled();
    try {
      await client.mutate({
        mutation: updatePostMutation,
        variables: {
          postId: id,
          courseId: courseId,
          title: cleanPostMessageTitle(title, userType),
          studentIds: studentIds,
          unitPlanId: isGoalTaggingEnabled ? null : _.get(unitPlan, "id", null),
          resourceId: isGoalTaggingEnabled
            ? null
            : _.get(resourceItem, "id", null),
          createdBy: userId,
          resourceType: isGoalTaggingEnabled
            ? null
            : resourceItem
            ? resourceType
            : null,
          elementsPYP: _.map(elementPYP, item =>
            _.omit(item, ["id", "__typename", "resolvedMinimalTree"])
          ),
          addedPractices: _.map(addedPractices, ({ id }) => id),
          removedPractices: _.map(removedPractices, ({ id }) => id),
          evidenceStatus: hasModuleAdminAccess({
            moduleName: MODULES.EVALUATION_CYCLES.id,
          })
            ? APPROVED_EVIDENCE_STATUS
            : SUGGESTED_EVIDENCE_STATUS,
          state: postState,
          evaluationCycleId,
          isPrivate: isPrivate,
          isHiddenFromStudents,
          updatedBy: userId,
          addedFolders: _.map(addedFromExistingFolders, folder => folder.id),
          createFolders,
          ...(!isPortfolioParityEnabled() ? { addedFolderNames } : {}),
          removedFolders: _.map(removedFolders, folder => folder.id),
          newAddedRatings: _.map(finalNewRatings, rating => ({
            ...rating,
            isPublished: true,
          })),
          removedRatings: finalRemovedRatings,
          isStudentIndividuallyRated: isStudentIndividuallyRated,
          approvComment: _.get(postDetails, "approveComment"),
          rejectComment: _.get(postDetails, "rejectComment"),
          addAttachments: _.map(updatedAttachments, item =>
            _.omit(
              item,
              (_.get(item, "type") == "WORKBOOK" &&
                _.get(postDetails, "shouldKeepWorkbookId", true) == true) ||
                isPortfolioParityEnabled()
                ? _.without(OMIT_ATTRIBUTES_OF_ATTACHMENTS, "id")
                : OMIT_ATTRIBUTES_OF_ATTACHMENTS
            )
          ),
          removeAttachmentIds: _.filter(
            _.map(removeAttachments, attachment => attachment?.id),
            value => !_.isNil(value)
          ),
          studentActivities: studentActivitiesInput,
          publishedAt:
            (postState === "REJECTED" &&
              isPortfolioReviewSetupEnabledAndIsReviewRoute()) ||
            ((isPublishingDraftPost ||
              _.isEqual(currentPostState, "IN_APPROVAL")) &&
              !moment.isMoment(_.get(postDetails, "publishedAt")))
              ? undefined
              : _.isNil(_.get(postDetails, "publishedAt"))
              ? moment().toISOString()
              : _.get(postDetails, "publishedAt"),
          academicTermId: _.get(postDetails, "academicTerm.id", null),
          aiConversationId: _.get(postDetails, "aiConversationId", null),
          ...(isNewGoalTaggingEnabled
            ? {
                taggedEntity: formatTaggedEntityUpdateInput(
                  postTaggedEntity,
                  _.get(oldPostDetails, "postTaggedEntity"),
                  getSelectedCurriculumId(getState())
                ),
              }
            : BLANK_OBJECT),
        },
        refetchQueries: isPortfolioReviewSetupEnabledAndIsReviewRoute()
          ? [
              {
                query: getOrganizationPostFeedQuery,
                variables: {
                  filters: {
                    curriculumProgramIds: [getSelectedCurriculumId(getState())],
                    state: "IN_APPROVAL",
                    creatorType: "staff",
                    academicYears: [getSelectedAcademicYearId(getState())],
                    fetchOnlyRevieweePosts: true,
                    feedTypes: ["PORTFOLIO"],
                  },
                  organizationId: _.get(getState(), "login.userInfo.org_id"),
                  uids: fieldUids,
                  translationFilter: translationFilter,
                  isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
                },
              },
            ]
          : [
              {
                query: getCourseAllStudentQuery,
                variables: {
                  id: courseId,
                  folderIds: getState().journal.filters.folderIds,
                  userArchivedFilters: {
                    academicYearId: getAcademicYearId(getState()),
                  },
                },
              },
              ...(getShouldShowFolderCount()
                ? [
                    {
                      query: getCourseFolders,
                      variables: {
                        courseId: courseId,
                        filters: _.omit(refetchQueryFilters, "folderIds"),
                      },
                    },
                  ]
                : []),
              ...taggedStudentFoldersRefetchQuery,
              ...(postState === "REJECTED"
                ? [
                    {
                      query: getCoursePostFeedQuery,
                      variables: {
                        id: courseId,
                        filters: refetchQueryFilters,
                        uids: fieldUids,
                        translationFilter: translationFilter,
                        isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
                      },
                    },
                  ]
                : []),
            ],
      });

      if (!_.isNil(isPublishingDraftPost) && isPublishingDraftPost)
        dispatch(
          setToastMsg({
            msg: "toastMsgs:post_successfully_published",
            type: "success",
            position: "toast-bottom-left",
          })
        );
      else {
        dispatch(
          setToastMsg({
            ...getPostCreationToastMessage({
              state: postState,
              isUpdate: true,
              publishedAt: _.isNil(_.get(postDetails, "publishedAt"))
                ? isPortfolioReviewSetupEnabledAndIsReviewRoute()
                  ? null
                  : moment().toISOString()
                : _.get(postDetails, "publishedAt"),
              oldPublishedAt: _.get(oldPostDetails, "publishedAt"),
            }),
            type: "success",
            position: "toast-bottom-left",
          })
        );
      }
      const filters = getState().journal.filters;
      const currentSelectedStudentInFilter = _.get(
        filters,
        "studentIds",
        undefined
      );
      // Keep student highlighted in filter after update/edit post
      const currentCurriculumProgramType = _.get(
        getState(),
        "platform.currentCurriculumProgram.type",
        CURRICULUM_TYPE_PYP
      );
      let filterStudentIds = undefined;
      if (userType == "student") {
        filterStudentIds = userId;
      } else if (
        userType == "staff" &&
        isDPSubjectJournalEnabled(currentCurriculumProgramType)
      ) {
        filterStudentIds = !_.includes(
          studentIds,
          currentSelectedStudentInFilter
        )
          ? _.get(studentIds, "0", currentSelectedStudentInFilter)
          : currentSelectedStudentInFilter;
      }
      if (!_.includes(filterStudentIds, filters.studentIds)) {
        dispatch(
          updateFilterObject({
            studentIds: filterStudentIds,
            unTagged: false,
          })
        );
      }
      if (getIsSchedulePostTabEnabled() && isScheduledPost) {
        // Navigate to scheduled tab if post is scheduled
        dispatch(
          updateFilterObject({
            state: "SCHEDULED",
            orderBy: getOrderBy({
              state: "SCHEDULED",
              currentCurriculumProgramType,
            }),
          })
        );
      } else if (
        !_.isNil(filters?.state) &&
        !_.isEqual(postState, filters.state)
      ) {
        if (userType === "student") {
          return;
        }
        const finalState = isDPSubjectJournalEnabled(
          currentCurriculumProgramType
        )
          ? _.get(getState(), "journal.filters.state", "ALL")
          : postState;
        dispatch(
          updateFilterObject({
            // For DP journal, let the status filter remain as it is set on the feed.
            state:
              isPortfolioReviewSetupEnabled() &&
              userType === "staff" &&
              finalState === "IN_APPROVAL" &&
              createdBy?.type === "staff"
                ? "IN_APPROVAL_STAFF"
                : finalState === "REJECTED" && userType === "staff"
                ? "IN_APPROVAL"
                : finalState,
            orderBy: getOrderBy({
              state: finalState,
              currentCurriculumProgramType,
            }),
          })
        );
      }
      if (!_.isEmpty(aiConversationId) && !_.isEmpty(id)) {
        dispatch(
          updateAiConversation({
            id: aiConversationId,
            entityId: id,
          })
        );
      }
    } catch (e) {
      console.warn(e);
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "success",
          position: "toast-bottom-left",
        })
      );
      throw e;
    }
  };
};

const updateFiltersObject = filters => {
  let updatedFilters = filters;
  if (updatedFilters?.state === "IN_APPROVAL_STAFF") {
    updatedFilters = {
      ...updatedFilters,
      state: "IN_APPROVAL",
    };
  }
  return updatedFilters;
};

const getReviewerPostFilters = (filters, userInfo) => {
  const state = _.get(filters, "state", "ALL");
  const filterWithoutState = _.omit(filters, ["state"]);
  const userType = userInfo.user_type;
  const userId = userInfo.id;
  if (
    userType === "staff" &&
    (state === "IN_APPROVAL_STAFF" || state === "IN_APPROVAL")
  ) {
    return {
      ...(filters.state === "IN_APPROVAL_STAFF" ? filterWithoutState : filters),
      states:
        filters.state === "IN_APPROVAL_STAFF"
          ? ["IN_APPROVAL", "REJECTED"]
          : filters.state,
      ...((filters.state === "IN_APPROVAL" ||
        filters.state === "IN_APPROVAL_STAFF") && {
        creatorType:
          userType === "staff" && filters.state === "IN_APPROVAL_STAFF"
            ? "staff"
            : "student",
      }),
      ...(filters.state === "IN_APPROVAL_STAFF" && { createdBy: userId }),
    };
  }

  return filters;
};

export const createPost = ({ postDetails, fromJournal = true }) => {
  return async (dispatch, getState) => {
    const {
      title,
      attachments,
      students: { edges: students = [] } = {},
      unitPlan,
      resourceItem,
      resourceType,
      elementPYP,
      state = "DRAFT",
      isPrivate,
      isHiddenFromStudents,
      folders,
      courseId,
      taggedPractices,
      curriculumProgramId,
      items,
      originalibPYPElementRatings: ibPYPElementRatings,
      originalIsStudentIndividuallyRated: isStudentIndividuallyRated,
      aiConversationId,
      activityLog,
      postTaggedEntity,
      publishedAt,
    } = postDetails;
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const userType = userInfo.user_type;

    const academicYearId = getSelectedAcademicYearId(getState());

    const isScheduledPost =
      publishedAt && moment(publishedAt).isAfter(moment());

    if (userType == "student") {
      if (
        _.isUndefined(_.find(students, student => student?.node?.id == userId))
      ) {
        students.push({
          node: getUserBasicDetailsFromCache({
            id: userId,
            type: userInfo?.userEntityType,
          }),
          __typename: "StudentsEdge",
        });
      }
    }

    const responseData = _.find(
      items,
      item => _.get(item, "itemType") === "STUDENT_ASSIGNMENT"
    );
    const studentAssignmentId = _.get(responseData, "item.id", null);
    const submissionType = _.get(responseData, "itemType", null);
    const isSharedWithStudent = _.get(
      responseData,
      "item.isSharedWithStudent",
      false
    );

    const refetchStudentAssignmentDetails = [];

    if (studentAssignmentId) {
      refetchStudentAssignmentDetails.push({
        query: getStudentAssignmentDetailsQuery,
        variables: {
          id: studentAssignmentId,
          showOnlySubmitted: false,
          userFilter: getToolResponseUserFilter(userType, isSharedWithStudent),
          entityEventsFilter: {
            orderBy: "EVENT_TIME",
            orderByDir: "ASC",
          },
        },
      });
    }

    const courseGradeFilters = {
      academicYearId,
    };

    let courseDetails = getCourseDetailsFromCache({
      id: courseId,
      courseGradeFilters,
    });
    if (_.isEmpty(courseDetails) && !!courseId) {
      courseDetails = await dispatch(
        getCourseDetails({ id: courseId, courseGradeFilters })
      );
    }

    const academicYears = _.map(
      _.get(courseDetails, "academicYears", []),
      item => item.id
    );

    const curriculumProgramType = getState().platform.currentCurriculumProgram
      .type;
    const fieldUids = getFieldUids({ curriculumProgramType });
    const refetchQueryFilters = getPostFeedFilters({
      userType: userType,
      filters:
        isPortfolioReviewSetupEnabled() && fromJournal
          ? updateFiltersObject(
              getReviewerPostFilters(
                _.get(getState(), "journal.filters"),
                userInfo
              )
            )
          : _.get(getState(), "journal.filters"),
    });

    const translationFilter = getPostTranslationFilter({
      userInfo,
      shouldTranslate: false,
      handleTranslation: hasTranslationPermission(),
    });
    const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();
    // Post rate on learning goals input variable
    const selectedGoalsRatings = [];
    _.forEach(elementPYP, element => {
      selectedGoalsRatings.push(
        ...getNestedTaggedLearningGoalsIds(element, _.get(element, "value", []))
      );
    });
    const ibPYPElementRatingsInput = [];

    _.forEach(ibPYPElementRatings, rating => {
      if (
        (_.some(
          selectedGoalsRatings,
          selectedRating =>
            selectedRating ==
            `${_.get(rating, "ibPYPElementType", undefined)}_${_.get(
              rating,
              "ibPYPElementId",
              undefined
            )}`
        ) ||
          rating?.ibPYPElementType === "DP_SUBJECT") &&
        !_.isUndefined(rating?.studentId)
      ) {
        const studentRating = {
          studentId: _.get(
            rating,
            "studentId",
            _.get(rating, "student.id", undefined)
          ),
          parentType: "POST",
          academicCriteriaValueId: _.get(
            rating,
            "academicCriteriaValue.id",
            undefined
          ),
          academicCriteriaSetId: _.get(
            rating,
            "academicCriteriaSet.id",
            undefined
          ),
          learningCourseId: getIsCourseBasedGradingEnabled()
            ? _.get(
                rating,
                "learningCourseId",
                getSelectedLearningCourseId(getState())
              )
            : undefined,
          ibPYPElementId: _.get(rating, "ibPYPElementId", undefined),
          ibPYPElementType: _.get(rating, "ibPYPElementType", ""),
          createdBy: userInfo.id,
          subjectId:
            !getIsCourseBasedGradingEnabled() ||
            getIsSubjectBasedGradingEnabled()
              ? _.get(rating, "subjectId", undefined)
              : undefined,
          academicTermId: _.get(postDetails, "academicTerm.id", null),
        };
        ibPYPElementRatingsInput.push(studentRating);
      }
    });

    const existingFolders = _.filter(
      folders,
      folder => _.get(folder, "isNewTag", false) == false
    );
    const folderNames = _.map(
      _.filter(folders, folder => _.get(folder, "isNewTag", false) == true),
      folder => _.get(folder, "name", "")
    );

    const taggedStudentFoldersRefetchQuery = [];
    if (isDPSubjectJournalEnabled(curriculumProgramType)) {
      taggedStudentFoldersRefetchQuery.push({
        query: getTaggedPostStudentFolders,
        variables: {
          courseId: courseId,
          studentIds: _.compact(_.map(students, item => item.node.id)),
        },
      });
    }

    // Process activity tracking
    let studentActivityInput = getStudentActivityInput({
      postDetails,
      userId,
    });
    if (_.isEmpty(studentActivityInput)) studentActivityInput = undefined;

    const createFolders = _.map(
      _.filter(folders, folder => _.get(folder, "isNewTag", false) == true),
      folder => ({
        name: _.get(folder, "name", ""),
        color: _.get(folder, "color", ""),
      })
    );

    try {
      const updatedAttachments = [];
      _.map(attachments, item => {
        if (_.get(item, "type") === "NOTE") {
          _.set(
            item,
            "title",
            cleanNoteMessage(_.get(item, "title")?.trim(), userType)
          );
        }
        updatedAttachments.push(item);
      });
      const results = await client.mutate({
        mutation: createPostMutation,
        variables: {
          courseId: courseId,
          title: cleanPostMessageTitle(title, userType),
          attachments: _.map(updatedAttachments, item =>
            _.omit(
              item,
              _.get(item, "type") == "WORKBOOK" &&
                _.get(postDetails, "shouldKeepWorkbookId", true) == true
                ? _.without(OMIT_ATTRIBUTES_OF_ATTACHMENTS, "id")
                : OMIT_ATTRIBUTES_OF_ATTACHMENTS
            )
          ),
          studentIds: _.compact(_.map(students, item => item.node.id)),
          unitPlanId: _.get(unitPlan, "id", null),
          resourceId: _.get(resourceItem, "id", null),
          createdBy: userId,
          practicesV2: getPracticesV2InputForPost({
            taggedPractices,
          }),
          resourceType: resourceItem ? resourceType : null,
          elementsPYP: _.map(elementPYP, element =>
            _.omit(element, ["resolvedMinimalTree", "__typename", "id"])
          ),

          ...(isNewGoalTaggingEnabled
            ? {
                taggedEntity: formatTaggedEntityCreateInput(
                  postTaggedEntity,
                  getSelectedCurriculumId(getState())
                ),
              }
            : BLANK_OBJECT),
          state: state,
          isPrivate: isPrivate,
          isHiddenFromStudents,
          publishedBy: userId,
          folders: _.map(existingFolders, folder => folder.id),
          ...(!isPortfolioParityEnabled() ? { folderNames } : {}), //removing this as support for this is added in createFolders.
          curriculumProgramId,
          parentId: studentAssignmentId,
          parentType: submissionType,
          academicYears,
          ibPYPElementRatings: _.map(ibPYPElementRatingsInput, rating => ({
            ...rating,
            isPublished: true,
          })),
          isStudentIndividuallyRated: isStudentIndividuallyRated,
          studentActivities: studentActivityInput,
          publishedAt: _.get(postDetails, "publishedAt"),
          academicTermId: _.get(postDetails, "academicTerm.id", null),
          createFolders,
          aiConversationId: _.get(postDetails, "aiConversationId", null),
          activityLog,
        },
        awaitRefetchQueries: true,
        refetchQueries: fromJournal
          ? [
              {
                query: getCoursePostFeedQuery,
                variables: {
                  id: courseId,
                  filters: refetchQueryFilters,
                  uids: fieldUids,
                  translationFilter: translationFilter,
                  isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
                },
              },
              {
                query: getCourseAllStudentQuery,
                variables: {
                  id: courseId,
                  folderIds: _.get(getState(), "journal.filters.folderIds", []),
                },
              },
              ...(getShouldShowFolderCount()
                ? [
                    {
                      query: getCourseFolders,
                      variables: {
                        courseId: courseId,
                        filters: _.omit(refetchQueryFilters, "folderIds"),
                      },
                    },
                  ]
                : []),
              ...refetchStudentAssignmentDetails,
              ...taggedStudentFoldersRefetchQuery,
            ]
          : [],
      });
      dispatch(
        setToastMsg({
          ...getPostCreationToastMessage({
            state,
            publishedAt: _.get(postDetails, "publishedAt", null),
            oldPublishedAt: null,
          }),
          type: "success",
          position: "toast-bottom-left",
        })
      );
      if (getIsSchedulePostTabEnabled() && isScheduledPost) {
        const currentCurriculumProgramType = _.get(
          getState(),
          "platform.currentCurriculumProgram.type",
          CURRICULUM_TYPE_PYP
        );

        dispatch(
          updateFilterObject({
            state: "SCHEDULED",
            orderBy: getOrderBy({
              state: "SCHEDULED",
              currentCurriculumProgramType,
            }),
          })
        );
      }
      if (
        !_.isEmpty(aiConversationId) &&
        !_.isEmpty(_.get(results, "data.documentation.createPost.id"))
      ) {
        dispatch(
          updateAiConversation({
            id: aiConversationId,
            entityId: _.get(results, "data.documentation.createPost.id"),
          })
        );
      }
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      throw e;
    }
  };
};

export const getCourseDetails = ({ id, courseGradeFilters }) => {
  return async (dispatch, getState) => {
    const result = await client.query({
      query: getCourseDetailsQuery,
      variables: {
        id,
        courseGradeFilters,
      },
      fetchPolicy: "network-only",
    });
    return _.get(result, "data.node", []);
  };
};

const getSubmissionPostMessage = ({ state, publishedAt }) => {
  const now = moment();
  const publishedMoment = publishedAt ? moment(publishedAt) : null;

  if (
    state === "PUBLISHED" &&
    publishedMoment &&
    publishedMoment.isAfter(now)
  ) {
    return {
      msg: "toastMsgs:post_scheduled_successfully_with_time",
      locale_params: [
        {
          key: "time",
          value: moment(publishedAt).format("lll"),
          isPlainText: true,
        },
      ],
    };
  }

  if (
    state === "PUBLISHED" &&
    publishedMoment &&
    publishedMoment.isBefore(now)
  ) {
    return { msg: "toastMsgs:post_backdated_successfully" };
  }

  if (
    state === "PUBLISHED" &&
    publishedMoment &&
    publishedMoment.isSameOrAfter(now)
  ) {
    return {
      msg: "toastMsgs:post_successfully_published",
    };
  }
};

export const updateAssignmentToJournal = ({ studentAssignmentIds }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const postDetails = getState().post.postDetails;

    const {
      state,
      assignmentId,
      title,
      unitPlan,
      resourceItem,
      resourceType,
      elementPYP,
      isPrivate,
      isHiddenFromStudents,
      folders,
      courseId,
      taggedPractices,
      curriculumProgramId,
      postTaggedEntity,
    } = postDetails;

    // For DP journal, we are allowing folder creation during post creation itself.
    // so folders having isNewTag needs to be created
    const existingFolders = _.filter(
      folders,
      folder => _.get(folder, "isNewTag", false) == false
    );
    const folderNames = _.map(
      _.filter(folders, folder => _.get(folder, "isNewTag", false) == true),
      folder => _.get(folder, "name", "")
    );

    const createFolders = _.map(
      _.filter(folders, folder => _.get(folder, "isNewTag", false) == true),
      folder => ({
        name: _.get(folder, "name", ""),
        color: _.get(folder, "color", ""),
      })
    );
    const academicYearId = getSelectedAcademicYearId(getState());
    const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();
    const isBulkAssignmentPostCreationEnhancementEnabled = getIsBulkAssignmentPostCreationEnhancementEnabled();
    try {
      await client.mutate({
        mutation: updateAssignmentToJournalMutation,
        variables: {
          assignmentId: assignmentId,
          studentAssignmentIds,
          postData: {
            courseId: courseId,
            title: title,
            unitPlanId: _.get(unitPlan, "id", null),
            resourceId: _.get(resourceItem, "id", null),
            createdBy: userId,
            practicesV2: getPracticesV2InputForPost({
              taggedPractices,
            }),
            resourceType: resourceItem ? resourceType : null,
            elementsPYP: _.map(elementPYP, element =>
              _.omit(element, ["resolvedMinimalTree"])
            ),
            state: state,
            isPrivate: isPrivate,
            isHiddenFromStudents,
            publishedBy: userId,
            publishedAt: _.get(postDetails, "publishedAt", undefined),
            folders: _.compact(_.map(existingFolders, folder => folder?.id)),
            folderNames,
            createFolders,
            curriculumProgramId,
            ...(isNewGoalTaggingEnabled
              ? {
                  taggedEntity: formatTaggedEntityCreateInput(
                    postTaggedEntity,
                    getSelectedCurriculumId(getState())
                  ),
                }
              : BLANK_OBJECT),
          },
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getAssignmentDetailsQuery,
            variables: getAssignmentDetailsQueryVariables({
              assignmentId,
              curriculumProgramType: getCurrentCurriculumProgramType(
                getState()
              ),
              userType: userInfo.user_type,
              userId,
              academicYearId,
            }),
          },
        ],
      });

      dispatch(
        setToastMsg({
          msg: isBulkAssignmentPostCreationEnhancementEnabled
            ? `toastMsgs:generating_posts`
            : `toastMsgs:posts_action_successfully`,
          locale_params: [
            !isBulkAssignmentPostCreationEnhancementEnabled
              ? {
                  key: "action",
                  value: `toastMsgs:created`,
                  isPlainText: false,
                }
              : {},
          ],
          ...getSubmissionPostMessage({
            state: state,
            publishedAt: _.get(postDetails, "publishedAt", undefined),
          }),
          type: isBulkAssignmentPostCreationEnhancementEnabled
            ? "info"
            : "success",
          position: "toast-bottom-left",
        })
      );
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const deleteAttachments = attachments => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: deleteAttachmentMutation,
        variables: {
          attachmentIds: _.map(attachments, attachment =>
            _.get(attachment, "id")
          ),
        },
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

const activityCreateComment = async ({
  userInfo,
  parentId,
  parentType,
  label,
  attachments,
  dispatch,
}) => {
  try {
    await client.mutate({
      mutation: createMessageMutation,
      variables: {
        parentId,
        parentType,
        subEntityType: "COMMENT",
        attachments: _.map(attachments, attachment =>
          _.omit(attachment, ATTACHMENT_OMIT_ATTRIBUTES)
        ),
        label,
      },
      optimisticResponse: {
        __typename: "Mutation",
        platform: {
          __typename: "PlatformMutations",
          createMessage: {
            id: generateRandomId(),
            isCommentRead: true,
            isRead: true,
            isPin: false,
            label: label,
            itemType: "ATTACHMENTS",
            type: "NORMAL",
            item: {
              id: generateRandomId(),
              attachments: attachments,
              __typename: "AttachmentSet",
            },
            createdAt: moment().toISOString(),
            createdBy: {
              ...getUserBasicDetailsFromCache({
                id: userInfo.id,
                type: userInfo.userEntityType,
              }),
              type: userInfo.user_type,
              schoolTenures: [],
            },
            messageReplies: {
              edges: [],
              __typename: "MessageRepliesConnection",
            },
            isDeleted: false,
            __typename: "Message",
          },
        },
      },
      update: (cache, { data }) => {
        const {
          platform: { createMessage },
        } = data;

        const likesAndComments = readActivityLikesAndCommentsFragment({
          id: parentId,
        });

        const comments = _.get(likesAndComments, ["comments", "edges"], []);

        const newComment = {
          node: {
            ..._.omit(createMessage, [
              "isPin",
              "messageReplies",
              "createdBy.schoolTenures",
            ]),
          },
          __typename: "ConversationMessageEdge",
        };

        // const updatedComments = _.concat(comments, newComment);
        const updatedComments = [newComment, ...comments];

        const newCommentObject = {
          ..._.get(likesAndComments, "comments", {}),
          edges: updatedComments,
          totalCount:
            _.get(likesAndComments, ["comments", "totalCount"], 0) + 1,
        };

        writeActivityLikesAndCommentsFragment({
          id: parentId,
          data: { ...likesAndComments, comments: newCommentObject },
        });
      },
    });
  } catch (e) {
    console.warn("Error in `activityCreateComment`", e);
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  }
};

const routineCreateComment = async ({
  userInfo,
  parentId,
  parentType,
  label,
  attachments,
  dispatch,
}) => {
  try {
    await client.mutate({
      mutation: createMessageMutation,
      variables: {
        parentId,
        parentType,
        subEntityType: "COMMENT",
        attachments: _.map(attachments, attachment =>
          _.omit(attachment, ATTACHMENT_OMIT_ATTRIBUTES)
        ),
        label,
      },
      optimisticResponse: {
        __typename: "Mutation",
        platform: {
          __typename: "PlatformMutations",
          createMessage: {
            id: generateRandomId(),
            isCommentRead: true,
            isRead: true,
            isPin: false,
            label: label,
            itemType: "ATTACHMENTS",
            itemTypeV2: "ATTACHMENTS",
            metadata: null,
            type: "NORMAL",
            item: {
              id: generateRandomId(),
              attachments: attachments,
              __typename: "AttachmentSet",
            },
            createdAt: moment().toISOString(),
            createdBy: {
              ...getUserBasicDetailsFromCache({
                id: userInfo.id,
                type: userInfo.userEntityType,
              }),
              type: userInfo.user_type,
              schoolTenures: [],
            },
            messageReplies: {
              edges: [],
              __typename: "MessageRepliesConnection",
            },
            isDeleted: false,
            __typename: "Message",
          },
        },
      },
      update: (cache, { data }) => {
        const {
          platform: { createMessage },
        } = data;

        const likesAndComments = readRoutineLikesAndCommentsFragment({
          id: parentId,
        });

        const comments = _.get(likesAndComments, ["comments", "edges"], []);

        const newComment = {
          node: {
            ..._.omit(createMessage, [
              "isPin",
              "messageReplies",
              "createdBy.schoolTenures",
            ]),
          },
          __typename: "ConversationMessageEdge",
        };

        // const updatedComments = _.concat(comments, newComment);
        const updatedComments = [newComment, ...comments];

        const newCommentObject = {
          ..._.get(likesAndComments, "comments", {}),
          edges: updatedComments,
          totalCount:
            _.get(likesAndComments, ["comments", "totalCount"], 0) + 1,
        };
        writeRoutineLikesAndCommentsFragment({
          id: parentId,
          data: { ...likesAndComments, comments: newCommentObject },
        });
      },
    });
  } catch (e) {
    console.warn("Error in `routineCreateComment`", e);
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  }
};

export const createComment = commentData => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const {
      parentId,
      parentType,
      subEntityType,
      attachments,
      label,
      cacheVariables,
      fragment,
    } = commentData;
    if (parentType === "STUDENT_ACTIVITY") {
      await activityCreateComment({
        userInfo,
        parentId,
        parentType,
        label,
        attachments,
        dispatch,
      });
      return;
    }

    if (parentType === "STUDENT_TEMPLATE_RESPONSE") {
      await routineCreateComment({
        userInfo,
        parentId,
        parentType,
        label,
        attachments,
        dispatch,
      });
      return;
    }

    const currentComments = readPostCommentFragment({
      postId: parentId,
      variables: cacheVariables,
      fragment: _.isNil(cacheVariables)
        ? fragment.post
        : fragment.postWithVariables,
    });

    try {
      await client.mutate({
        mutation: createMessageMutation,
        variables: {
          parentId: parentId,
          parentType: parentType,
          subEntityType: subEntityType,
          attachments: _.map(attachments, attachment =>
            _.omit(attachment, ATTACHMENT_OMIT_ATTRIBUTES)
          ),
          label: label,
        },
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            __typename: "PlatformMutations",
            createMessage: {
              id: generateRandomId(),
              isCommentRead: true,
              isRead: true,
              label: label,
              itemType: "ATTACHMENTS",
              itemTypeV2: "ATTACHMENTS",
              metadata: null,
              type: "NORMAL",
              item: {
                id: generateRandomId(),
                attachments: attachments,
                __typename: "AttachmentSet",
              },
              createdAt: moment().toISOString(),
              createdBy: {
                ...getUserBasicDetailsFromCache({
                  id: userInfo.id,
                  type: userInfo.userEntityType,
                }),
                type: userInfo.user_type,
              },
              isDeleted: false,
              __typename: "Message",
            },
          },
        },
        update: (cache, { data }) => {
          const {
            platform: { createMessage },
          } = data;
          const updatedComments = [
            {
              node: createMessage,
              __typename: "ConversationMessageEdge",
            },
            ..._.get(currentComments, "comments.edges", []),
          ];
          const updatedUnreadComments = [
            {
              node: createMessage,
              __typename: "ConversationMessageEdge",
            },
            ..._.get(currentComments, "comments.unreadCommentsEdges", []),
          ];
          const commentsObject = {
            ..._.get(currentComments, "comments", {}),
            edges: updatedComments,
            ...(!_.isEmpty(
              _.get(currentComments, "comments.unreadCommentsEdges", [])
            )
              ? { unreadCommentsEdges: updatedUnreadComments }
              : {}),
            totalCount: _.get(currentComments, "comments.totalCount", 0) + 1,
          };

          setTimeout(() => {
            writePostCommentFragment({
              postId: parentId,
              variables: cacheVariables,
              data: {
                ...currentComments,
                comments: commentsObject,
              },
              fragment: _.isNil(cacheVariables)
                ? fragment.post
                : fragment.postWithVariables,
            });
          });
        },
      });
    } catch (e) {
      setTimeout(() => {
        writePostCommentFragment({
          postId: parentId,
          data: {
            ...currentComments,
            comments: {
              ..._.get(currentComments, "comments", {}),
            },
          },
          variables: cacheVariables,
          fragment: _.isNil(cacheVariables)
            ? fragment.post
            : fragment.postWithVariables,
        });
      });
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

const activityDeleteComment = async ({ commentData, dispatch }) => {
  const { parentId, commentId } = commentData;

  try {
    const result = await client.mutate({
      mutation: deleteMessageMutation,
      variables: {
        id: commentId,
      },
      optimisticResponse: {
        platform: {
          deleteMessage: true,
          __typename: "PlatformMutations",
        },
      },
      update: (cache, { data }) => {
        const likesAndComments = readActivityLikesAndCommentsFragment({
          id: parentId,
        });

        const updatedComments = _.filter(
          _.get(likesAndComments, "comments.edges", []),
          comment => _.get(comment, "node.id") != commentId
        );

        const commentsObject = {
          ..._.get(likesAndComments, "comments", {}),
          edges: updatedComments,
          totalCount: _.size(updatedComments),
        };

        setTimeout(() => {
          writeActivityLikesAndCommentsFragment({
            id: parentId,
            data: { ...likesAndComments, comments: commentsObject },
          });
        });
      },
    });
    if (_.get(result, "data.platform.deleteMessage", false) == true) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:comment_successfully_deleted",
          type: "success",
          position: "toast-bottom-left",
        })
      );
    }
  } catch (e) {
    console.warn("Error in `activityDeleteComment`", e);
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  }
};

const routineDeleteComment = async ({ commentData, dispatch }) => {
  const { parentId, commentId } = commentData;

  try {
    const result = await client.mutate({
      mutation: deleteMessageMutation,
      variables: {
        id: commentId,
      },
      optimisticResponse: {
        platform: {
          deleteMessage: true,
          __typename: "PlatformMutations",
        },
      },
      update: (cache, { data }) => {
        const likesAndComments = readRoutineLikesAndCommentsFragment({
          id: parentId,
        });

        const updatedComments = _.filter(
          _.get(likesAndComments, "comments.edges", []),
          comment => _.get(comment, "node.id") != commentId
        );

        const commentsObject = {
          ..._.get(likesAndComments, "comments", {}),
          edges: updatedComments,
          totalCount: _.size(updatedComments),
        };

        setTimeout(() => {
          writeRoutineLikesAndCommentsFragment({
            id: parentId,
            data: { ...likesAndComments, comments: commentsObject },
          });
        });
      },
    });
    if (_.get(result, "data.platform.deleteMessage", false) == true) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:comment_successfully_deleted",
          type: "success",
          position: "toast-bottom-left",
        })
      );
    }
  } catch (e) {
    console.warn("Error in `routineDeleteComment`", e);
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  }
};

export const deleteComment = commentData => {
  return async (dispatch, getState) => {
    /* if first is given, means only one comment is fetched and visible,
    so if user deleting that comment there is no more comments in cache to show, that's why refetchQueries will be called to fetch next comment  */
    /* if we have more than one comments and "view all comments" is clicked, we can optimistically update the UI, no need of refetchQueries */
    const {
      parentId,
      parentType,
      commentId,
      cacheVariables,
      fragment,
    } = commentData;

    if (parentType === "STUDENT_ACTIVITY") {
      await activityDeleteComment({ commentData, dispatch });
      return;
    }

    if (parentType === "STUDENT_TEMPLATE_RESPONSE") {
      await routineDeleteComment({ commentData, dispatch });
      return;
    }

    const currentComments = readPostCommentFragment({
      postId: parentId,
      variables: cacheVariables,
      fragment: _.isNil(cacheVariables)
        ? fragment.post
        : fragment.postWithVariables,
    });
    try {
      const result = await client.mutate({
        mutation: deleteMessageMutation,
        variables: {
          id: commentId,
        },
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            __typename: "PlatformMutations",
            deleteMessage: {
              id: generateRandomId(),
              isDeleted: true,
              __typename: "Message",
            },
          },
        },
        update: (cache, { data }) => {
          const updatedComments = _.filter(
            _.get(currentComments, "comments.edges"),
            comment => _.get(comment, "node.id") != commentId
          );
          const updatedUnreadComments = _.filter(
            _.get(currentComments, "comments.unreadCommentsEdges"),
            comment => _.get(comment, "node.id") != commentId
          );
          const commentsOfPost = {
            ..._.get(currentComments, "comments"),
            edges: updatedComments,
            ...(!_.isEmpty(
              _.get(currentComments, "comments.unreadCommentsEdges", [])
            )
              ? { unreadCommentsEdges: updatedUnreadComments }
              : {}),
            totalCount: _.get(currentComments, "comments.totalCount", 1) - 1,
          };

          setTimeout(() => {
            writePostCommentFragment({
              postId: parentId,
              data: {
                ...currentComments,
                comments: commentsOfPost,
              },
              variables: cacheVariables,
              fragment: _.isNil(cacheVariables)
                ? fragment.post
                : fragment.postWithVariables,
            });
          });
        },
      });
      if (_.get(result, "data.platform.deleteMessage", false) == true) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:comment_successfully_deleted",
            type: "success",
            position: "toast-bottom-left",
          })
        );
      }
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

const activityUpdateComment = async ({ commentData, dispatch, userInfo }) => {
  const { id, attachments, label, parentId } = commentData;

  try {
    await client.mutate({
      mutation: updateMessageMutation,
      variables: {
        id: id,
        attachments: _.map(attachments, attachment =>
          _.omit(attachment, ATTACHMENT_OMIT_ATTRIBUTES)
        ),
        label: label,
      },
      optimisticResponse: {
        __typename: "Mutation",
        platform: {
          __typename: "PlatformMutations",
          updateMessage: {
            id: generateRandomId(),
            label: label,
            itemType: "ATTACHMENTS",
            type: "NORMAL",
            item: {
              id: generateRandomId(),
              attachments: attachments,
              createdAt: new Date().toISOString(),
              __typename: "AttachmentSet",
            },
            isCommentRead: true,
            isRead: true,
            isPin: false,
            createdBy: {
              ...getUserBasicDetailsFromCache({
                id: userInfo.id,
                type: userInfo.userEntityType,
              }),
              type: userInfo.user_type,
              profile_image: userInfo.profile_image,
              schoolTenures: [],
            },
            isDeleted: false,
            createdAt: new Date().toISOString(),
            messageReplies: {
              edges: [],
              __typename: "MessageRepliesConnection",
            },
            __typename: "Message",
          },
        },
      },
      update: (cache, { data }) => {
        const {
          platform: { updateMessage },
        } = data;

        const likesAndComments = readActivityLikesAndCommentsFragment({
          id: parentId,
        });

        const comment = _.find(
          _.get(likesAndComments, ["comments", "edges"], []),
          comment => _.get(comment, "node.id") == id
        );

        _.set(comment, "node.label", _.get(updateMessage, "label", ""));

        const newCommentObject = {
          ..._.get(likesAndComments, "comments", {}),
          edges: _.get(likesAndComments, ["comments", "edges"], []),
        };

        setTimeout(() => {
          writeActivityLikesAndCommentsFragment({
            id: parentId,
            data: { ...likesAndComments, comments: newCommentObject },
          });
        });
      },
    });
  } catch (e) {
    console.warn("Error in `activityUpdateComment`", e);
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  }
};

const routineUpdateComment = async ({ commentData, dispatch, userInfo }) => {
  const { id, attachments, label, parentId } = commentData;

  try {
    await client.mutate({
      mutation: updateMessageMutation,
      variables: {
        id: id,
        attachments: _.map(attachments, attachment =>
          _.omit(attachment, ATTACHMENT_OMIT_ATTRIBUTES)
        ),
        label: label,
      },
      optimisticResponse: {
        __typename: "Mutation",
        platform: {
          __typename: "PlatformMutations",
          updateMessage: {
            id: generateRandomId(),
            label: label,
            itemType: "ATTACHMENTS",
            itemTypeV2: "ATTACHMENTS",
            metadata: null,
            type: "NORMAL",
            item: {
              id: generateRandomId(),
              attachments: attachments,
              createdAt: new Date().toISOString(),
              __typename: "AttachmentSet",
            },
            isCommentRead: true,
            isRead: true,
            isPin: false,
            createdBy: {
              ...getUserBasicDetailsFromCache({
                id: userInfo.id,
                type: userInfo.userEntityType,
              }),
              type: userInfo.user_type,
              profile_image: userInfo.profile_image,
              schoolTenures: [],
            },
            isDeleted: false,
            createdAt: new Date().toISOString(),
            messageReplies: {
              edges: [],
              __typename: "MessageRepliesConnection",
            },
            __typename: "Message",
          },
        },
      },
      update: (cache, { data }) => {
        const {
          platform: { updateMessage },
        } = data;

        const likesAndComments = readRoutineLikesAndCommentsFragment({
          id: parentId,
        });

        const comment = _.find(
          _.get(likesAndComments, ["comments", "edges"], []),
          comment => _.get(comment, "node.id") == id
        );

        _.set(comment, "node.label", _.get(updateMessage, "label", ""));

        const newCommentObject = {
          ..._.get(likesAndComments, "comments", {}),
          edges: _.get(likesAndComments, ["comments", "edges"], []),
        };

        setTimeout(() => {
          writeRoutineLikesAndCommentsFragment({
            id: parentId,
            data: { ...likesAndComments, comments: newCommentObject },
          });
        });
      },
    });
  } catch (e) {
    console.warn("Error in `RoutineUpdateComment`", e);
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  }
};

export const updateComment = commentData => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const { id, attachments, label, parentType } = commentData;

    if (parentType === "STUDENT_ACTIVITY") {
      await activityUpdateComment({ commentData, dispatch, userInfo });
      return;
    }

    if (parentType === "STUDENT_TEMPLATE_RESPONSE") {
      await routineUpdateComment({ commentData, dispatch, userInfo });
      return;
    }

    const currentComment = readCommentOfPostFromCache({
      id: id,
    });

    try {
      await client.mutate({
        mutation: updateMessageMutation,
        variables: {
          id: id,
          attachments: _.map(attachments, attachment =>
            _.omit(attachment, ATTACHMENT_OMIT_ATTRIBUTES)
          ),
          label: label,
        },
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            __typename: "PlatformMutations",
            updateMessage: {
              id: generateRandomId(),
              label: label,
              itemType: "ATTACHMENTS",
              type: "NORMAL",
              item: {
                id: generateRandomId(),
                attachments: attachments,
                __typename: "AttachmentSet",
              },
              isCommentRead: true,
              isRead: true,
              createdBy: {
                ...getUserBasicDetailsFromCache({
                  id: userInfo.id,
                  type: userInfo.userEntityType,
                }),
                type: userInfo.user_type,
              },
              isDeleted: false,
              __typename: "Message",
            },
          },
        },
        update: (cache, { data }) => {
          const {
            platform: { updateMessage },
          } = data;
          setTimeout(() => {
            writeCommentOfPostInCache({
              id: id,
              data: updateMessage,
            });
          });
        },
      });
    } catch (e) {
      setTimeout(() => {
        writeCommentOfPostInCache({
          id: id,
          data: {
            currentComment,
          },
        });
      });
      console.error(e);
    }
  };
};

// Reducer method for manage-folder modal (useReducer)
export const folderManagementReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "SET_FOLDERS":
      state = update(state, {
        folders: { $set: payload.folders },
      });
      return state;

    case "ADD_NEW_FOLDER":
      // immutable update to add new folder at first position of array
      state = update(state, {
        folders: {
          $set: [{ ...payload.folderToAdd }, ...state.folders],
        },
      });
      return state;

    case "REMOVE_FOLDER":
      state = update(state, {
        folders: {
          $set: _.filter(
            state?.folders,
            folder => folder.id !== payload.folderId
          ),
        },
      });
      return state;
    case "UPDATE_FOLDER":
      state = update(state, {
        folders: {
          $set: _.map(state?.folders, folder => {
            if (folder.id === payload.updatedFolder.id) {
              return {
                ...folder,
                ...payload.updatedFolder,
              };
            }
            return folder;
          }),
        },
      });
      return state;
  }
};

export const bulkCourseFoldersActions = ({
  existingFolders,
  folders,
  onSuccessCallback = _.noop,
  setShowFullScreenLoader,
  courseIdFromParent,
}) => {
  return async (dispatch, getState) => {
    const courseId =
      _.get(getState(), "teacher.selected_class.selected_course") ||
      courseIdFromParent;
    // Create folders if not exist in course
    const foldersToCreate = _.differenceBy(folders, existingFolders, "id");

    // Remove folders if it exists in course but not in current set of folders
    const foldersToRemove = _.compact(
      _.map(_.differenceBy(existingFolders, folders, "id"), folder => folder.id)
    );

    // Update folders if it exists in course and also in current set of folders but with different name or color
    const foldersToCheckForUpdate = _.differenceBy(
      folders,
      foldersToCreate,
      "id"
    );

    // transform existingFolders array to object for easy lookup
    const mappedExistingFolders = _.keyBy(
      existingFolders,
      folder => "FOLDER_" + folder.id
    );

    const foldersToUpdate = [];
    _.forEach(foldersToCheckForUpdate, folder => {
      const existingFolder = mappedExistingFolders["FOLDER_" + folder.id];
      if (
        existingFolder.name !== folder.name ||
        existingFolder.color !== folder.color
      ) {
        foldersToUpdate.push(_.omit(folder, "__typename"));
      }
    });

    setShowFullScreenLoader(true);
    const response = await client.mutate({
      mutation: bulkCourseFoldersActionsMutation,
      variables: {
        input: {
          deleteFolders: _.compact(foldersToRemove),
          updateFolders: _.map(_.compact(foldersToUpdate), item =>
            _.omit(item, "totalPostCount")
          ),
          createFolders: {
            courseId,
            type: "JOURNAL",
            folderData: _.compact(
              _.map(foldersToCreate, folder => ({
                name: _.get(folder, "name", ""),
                color: _.get(folder, "color"),
              }))
            ),
          },
        },
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: getCourseFolders,
          variables: {
            courseId: courseId,
          },
        },
      ],
    });
    setShowFullScreenLoader(false);
    onSuccessCallback?.();
    const isSuccess = _.get(
      response,
      "data.documentation.bulkFolderAction.isSuccess"
    );
    const bulkFolderActionWarning = _.get(
      response,
      "data.documentation.bulkFolderAction.warning"
    );
    if (!_.isEmpty(bulkFolderActionWarning)) {
      dispatch(
        setToastMsg(
          _.includes(bulkFolderActionWarning, "Duplicate folder names found")
            ? "toastMsgs:duplicate_folder_names_warning"
            : "toastMsgs:something_went_wrong"
        )
      );
      return;
    }
    if (
      isSuccess &&
      (_.size(foldersToRemove) ||
        _.size(foldersToUpdate) ||
        _.size(foldersToCreate))
    ) {
      dispatch(
        setToastMsg({
          msg:
            _.size(foldersToRemove) > 1 ||
            _.size(foldersToUpdate) > 1 ||
            _.size(foldersToCreate) > 1
              ? "toastMsgs:folders_successfully_action"
              : "toastMsgs:folder_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:updated", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

export const upsertActivityPostCommentsAsRead = ({ userId, entityId }) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: upsertActivityPostCommentsAsReadMutation,
        variables: {
          input: [
            {
              userId,
              entityId,
              entityType: "STUDENT_ACTIVITY",
              isNew: false,
              isRead: true,
            },
          ],
        },
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            __typename: "PlatformMutations",
            upsertUserEntityState: {
              isSuccess: true,
              warning: {},
              __typename: "UpsertUserEntityStateResponse",
            },
          },
        },
        update: (cache, { data }) => {
          const {
            platform: { upsertUserEntityState },
          } = data;

          if (!upsertUserEntityState.isSuccess) {
            return;
          }

          const likesAndComments = readActivityLikesAndCommentsFragment({
            id: entityId,
          });
          const comments = _.get(likesAndComments, ["comments"], {});

          setTimeout(() => {
            writeActivityLikesAndCommentsFragment({
              id: entityId,
              data: {
                ...likesAndComments,
                comments: {
                  ...comments,
                  unreadCountV2: 0,
                },
              },
            });
          });
        },
      });
    } catch (e) {
      console.warn("Error in `upsertActivityPostCommentsAsRead`", e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export let cancelRequest;

export const generateAIResponse = ({
  action,
  message = "",
  curriculumProgramId = "",
  entityType = "PORTFOLIO",
  fieldType = "PORTFOLIO",
  cursorPositionIncludingHTML,
  getNextBlockIndex,
  insertNextBlockHandler,
  handleToddleAIGeneration = () => {},
  updatePromptBoxContentLocally = () => {},
  promptBoxContent = "",
  isPromptAction = false,
  context = {},
  updatePromptBox = false,
  updateTextAreaLocally,
  selectedText = "",
  courseId,
  unitPlanId,
  leId,
  studentIds,
  studentIdToNameMap,
  updatePromptStatus,
  elementPYP,
  selectFromAllPYP,
  t,
  changeStreamText,
}) => {
  return async (dispatch, getState) => {
    try {
      let result = {};
      const updatedMessage = handleToddleAIGeneration({ message });
      const {
        preCursorText,
        postCursorText,
        placementIndex,
      } = getNextBlockIndex({
        message: updatedMessage,
        cursorPositionIncludingHTML,
      });
      const filteredContext = _.omitBy(
        context,
        value => value === "" || value === "{}"
      );

      let goalsMetadataKey = "learningGoals";
      if (!_.isEmpty(leId)) {
        goalsMetadataKey = "leLearningGoals";
      } else if (!_.isEmpty(unitPlanId)) {
        goalsMetadataKey = "unitLearningGoals";
      } else if (selectFromAllPYP) {
        goalsMetadataKey = "learningGoals";
      }

      const goalsMetadata = {
        [goalsMetadataKey]: _.compact(
          _.map(elementPYP, goal => {
            if (_.isEmpty(_.get(goal, "value"))) return;
            return {
              type: _.get(goal, "uid", _.get(goal, "fieldUID", "")),
              value: _.get(goal, "value", []),
            };
          })
        ),
      };
      const metadata = {
        courseId,
        ...(!_.isEmpty(leId) ? { leId: leId } : {}),
        ...(!_.isEmpty(unitPlanId) && _.isEmpty(leId)
          ? { unitPlanId: unitPlanId }
          : {}),
        ...(!_.isEmpty(goalsMetadata) ? goalsMetadata : {}),
        ...(_.size(studentIds) <= 3 ? { studentIds } : {}),
      };

      const filteredMetaData = _.omitBy(
        metadata,
        value => _.isEmpty(value) || _.isUndefined(value)
      );
      const response = await dispatch(
        getAIResponse({
          variables: {
            input: isPromptAction
              ? {
                  action,
                  context: filteredContext,
                  entityType: "GENERIC_TEXT",
                  fieldType: "ENHANCE",
                  module: "PORTFOLIO",
                }
              : {
                  entityType,
                  action,
                  context: filteredContext,
                  curriculumProgramId,
                  fieldType: "PORTFOLIO",
                  metadata: filteredMetaData,
                },
          },
          getCancelToken: token => (cancelRequest = token),
          onDownloadProgress: params => {
            const { content, state } = params || {};
            changeStreamText &&
              state &&
              updatePromptStatus(t("common:writing"));
            // Replace the placeholder with the student name
            let updatedContent = content;
            updatedContent = replaceCaptionWithIdAndNameMapping(
              content,
              studentIdToNameMap
            );
            const isStudentSeparatorFound = _.includes(updatedContent, "⌴");
            if (isStudentSeparatorFound) {
              return;
            }

            if (updatePromptBox) {
              updatePromptBoxContentLocally({
                content: promptBoxContent + updatedContent,
              });
            } else {
              updateTextAreaLocally({
                title: insertNextBlockHandler({
                  preCursorText,
                  postCursorText,
                  placementIndex,
                  contentInserted: updatedContent,
                  isMessageEmpty: _.isEmpty(updatedMessage),
                }),
              });
            }

            result = {
              isSuccess: true,
              content: updatedContent,
              updatedPostCaption: insertNextBlockHandler({
                preCursorText,
                postCursorText,
                placementIndex,
                contentInserted: updatedContent,
                isMessageEmpty: _.isEmpty(updatedMessage),
              }),
            };
          },
        })
      );

      const {
        usageMetricsId,
        model,
        temperature: currentTemperature,
        userInputFlagged = false,
      } = response || {};
      if (
        !_.get(getState(), "post.postDetails.aiConversationId") &&
        !_.includes(["change_this", "discard", "keep"], action)
      ) {
        await dispatch(createAIConversation());
      }
      await dispatch(
        onSendQuery({
          metadata: {
            fieldType: "CREATE",
            userInputFlagged: userInputFlagged,
            model: model,
            temperature: currentTemperature,
            language: "en",
            source: "WEB",
          },
          usageMetricsId: _.get(response, "usageMetricsId"),
          authorType: "assistant",
          content: _.get(result, "content"),
        })
      );

      return {
        usageMetricsId,
        userInputFlagged,
        model,
        currentTemperature,
        ...result,
      };
    } catch (e) {
      return { isSuccess: false };
    }
  };
};

export const createAIConversation = () => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: createAIConversationMutation,
        variables: {
          input: {
            entityType: "POST",
          },
        },
        update: (cache, { data }) => {
          dispatch(
            updatePost({
              aiConversationId: _.get(
                data,
                "ai.createAiConversation.response.id"
              ),
            })
          );
        },
      });
    } catch (error) {}
  };
};

export const onSendQuery = payload => {
  return async (dispatch, getState) => {
    try {
      if (!_.get(getState(), "post.postDetails.aiConversationId")) {
        await dispatch(createAIConversation());
      }
      const response = await dispatch(
        createAIMessage({
          variables: {
            input: {
              conversationId: _.get(
                getState(),
                "post.postDetails.aiConversationId"
              ),
              authorType: _.get(payload, "authorType", "user"),
              content: _.get(payload, "content"),
              metadata: _.get(payload, "metadata"),
              usageMetricsId: _.get(payload, "usageMetricsId", null),
              parentMessageId: _.get(
                getState(),
                "post.postDetails.lastAIMessageId",
                null
              ),
            },
          },
          writeToCache: false,
        })
      );
      dispatch(
        updatePost({
          lastAIMessageId: _.get(
            response,
            "data.ai.createAiMessage.response.id"
          ),
        })
      );
    } catch (error) {}
  };
};

export const updateAiConversation = input => {
  return async () => {
    try {
      const result = await client.mutate({
        mutation: updateAiConversationMutation,
        variables: {
          input,
        },
      });
      return _.get(result, "data.ai.updateAiConversation.isSuccess", false);
    } catch (error) {}
  };
};

const initialState = {
  postDetails: {
    postIds: [],
    studentIds: [],
    taggedPYPElements: {},
    taggedPYPChildren: [],
    resourceId: null,
    resourceType: null,
    attachments: [],
    activityIds: [],
    courseId: null,
    title: "",
    isResourceUpdate: true,
    state: "DRAFT",
    comments: {},
    likes: {},
    isPrivate: true,
    isHiddenFromStudents: true,
    isResourceSkipped: false,
    folders: [],
    folderNames: [],
    selectedFolders: [],
    taggedPractices: [],
    addedFolders: [],
    removedFolders: [],
    addedFolderNames: [],
    ibPYPElementRatings: [],
    originalibPYPElementRatings: [],
    isStudentIndividuallyRated: false,
    originalIsStudentIndividuallyRated: false,
    removeAttachmentIds: [],
    addAttachments: [],
    createFolders: [],
    postTaggedEntity: [],
  },
  postCreationMode: "new",
  studentListFilters: {
    searchText: "",
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export const createAttachmentGroups = ({
  input,
  portalType,
  groupParentId,
  groupParentType,
}) => {
  return async dispatch => {
    try {
      const result = await client.mutate({
        mutation: createAttachmentGroupsMutation,
        variables: {
          input,
          portalType,
        },
        update: (
          cache,
          {
            data: {
              platform: { createAttachmentGroups },
            },
          }
        ) => {
          const {
            parentId: inputParentId,
            parentType: inputParentType,
          } = input;
          const parentId = groupParentId ? groupParentId : inputParentId;
          const parentType = groupParentType
            ? groupParentType
            : inputParentType;
          if (!isExcludedParentTypesForAttachmentCache({ parentType })) {
            const nodeDetails = getAttachmentGroupsOfNodeForStudentAssignmentFromCache(
              {
                id: parentId,
              }
            );
            const attachmentGroups =
              _.get(nodeDetails, "attachmentGroups", []) || [];

            const data = {
              ...nodeDetails,
              attachmentGroups: [
                ...attachmentGroups,
                ...createAttachmentGroups,
              ],
            };

            writeAttachmentGroupsOfNodeForStudentAssignmentInCache({
              id: parentId,
              data,
            });
          }
        },
      });

      return _.get(result, "data.platform.createAttachmentGroups", []);
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return [];
    }
  };
};
